.modal {
  min-width: 30rem;
  max-width: 30rem;
}

.modelBody {
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  gap: 1rem;
}

.errorContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  background-color: var(--sentiment-background-negative);
  border-radius: 12px;
  margin-bottom: 10px;
}

.lastError {
  margin-bottom: 0px;
}

.errorCodeText {
  text-wrap: nowrap;
}

.errorIcon {
  color: var(--sentiment-text-negative);
  min-width: 22px;
  min-height: 22px;
}

.errorText {
  color: var(--sentiment-text-negative) !important;
}

.header {
  display: flex;
  gap: 1rem;
}

.modalFooter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.inventoryImage {
  padding: 0.5rem;
  border-radius: 12px;
  border: 1px solid var(--static-divider-standard);
}

.metaDataContainer {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}

.marginBottom {
  margin-bottom: 5px;
}

.metaDataSubContainer {
  display: flex;
  flex-direction: column;
}

.metaDataTitle {
  font-size: var(--fs-normal);
  color: var(--static-text-strong);
  font-weight: 500;
  text-overflow: ellipsis;
  line-height: 24px;
  overflow: hidden;
  text-wrap: nowrap;
}

.skuAndCondition {
  display: flex;
  gap: 0.5rem;
}

.subTitleContainer {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.subMetaTitle {
  font-size: 12px;
  color: var(--static-text-weak);
  font-weight: 400;
  line-height: 16px
}

.subMetaValue {
  font-size: 12px;
  color: var(--static-text-standard);
  font-weight: 400;
  line-height: 16px
}

.statusBadge {
  font-size: 12px;
}

.dot {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--static-text-weak);
  font-size: 12px
}

.infoContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
  background-color: var(--sentiment-background-info);
  border-radius: 12px;
  width: 100%;
}

.infoIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--sentiment-text-info);
}

.infoText {
  color: var(--sentiment-text-info);
}